import { render, staticRenderFns } from "./AdminCountries.vue?vue&type=template&id=998e3d76&scoped=true&"
import script from "./AdminCountries.vue?vue&type=script&lang=js&"
export * from "./AdminCountries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "998e3d76",
  null
  
)

export default component.exports